<template>
	<div class="steps-wrapper">
		<div class="steps">
			<Step v-for="(step, i) in activeSteps" :step="step" :key="i" :iteration="i" />
		</div>
		<StepNavigation />
	</div>
</template>

<script>
import { mapState } from "vuex";
import Step from "@/components/Step";
import StepNavigation from "@/components/StepNavigation";

export default {
	name: "Steps",
	components: { Step, StepNavigation },
	computed: {
		activeSteps() {
			return this.$store.getters["configurator/activeSteps"];
		},
		...mapState({
			config: state => state.configurator.config,
			currentStep: state => state.configurator.currentStep
		})
	}
};
</script>

<style lang="scss" scoped>
.steps-wrapper {
	.steps {
		> .step:last-of-type {
			margin-bottom: 0;
			padding-bottom: 0;
			overflow: initial;
		}
	}
	@media only screen and (min-width: $viewport-desktop) {
		height: 100%;

		.steps {
			height: calc(100% - 80px);
			overflow-x: hidden;
			overflow-y: auto;
			position: relative;
		}
	}
}
</style>
